import React from "react";
import Footer from "../Footer.js";
import './uniqueclasses.css'
import Pic1 from './Media/IMG_0784.jpg'
import Pic2 from './Media/IMG_0780.jpg'
import { NavLink } from "react-router-dom";
import ReactGA from 'react-ga4';




ReactGA.send({ hitType: "pageview", page: "/humankineziologia", title: "Humankineziologia & Joga Liaval" });

function Humankineziologia() {
  


  return (
    <div>
            
<div className="book-main-container"> 

  <div className="unique-class-title-lia liapicture">
    <div className="unique-class-title-left">
      <h1>Humánkineziológia &amp; Jóga Liával</h1>
      <p className="title-short-desc">
        Egyéni sportrehabilitáció, teljesítményfokozás, jógaterápia, jóga, táplálkozási- és életmód tanácsadás
      </p>
      <div className="personal-data-lia">
        <a href="mailto:info@liafit.hu">info@liafit.hu</a>
        <a href="tel:+36703836041">+36 70 383 6041</a>
      </div>
    </div>
  </div>

  <p className="title-short-desc-under">
  Célom a mozgás örömének és gyógyító hatásainak megismertetése másokkal is. Segíteni az embereket
önmaguk jobb megismerésében és az önfejlesztésben testgyakorlatokkal, légzőgyakorlatokkal, relaxációs és
meditációs technikák által, miközben a holisztikus és prevenciós szemléleteket helyezem a középpontba.</p>

  <div className="container">
    <div className="inside-container">
      <div className="class-description">
        <div className="class-description-text">

          <h2 className="class-description-h2">Sport- és táplálkozástudományi szakemberként fő szolgáltatásaim:</h2>

          <p className="list-main">Állapotfelmérés</p>
          <ul>
            <li>Az első alkalommal felmérem a jelenlegi állapotod, megvizsgálom az esetleges
tartáshibákat, mozgásbeli eltéréseket, és közösen meghatározzuk a céljaid. Ezek alapján összeállítom a
számodra legmegfelelőbb gyakorlatokat.</li>
            <li>Ha szükséges, további orvosi vizsgálatokat és/vagy komplexebb tesztek elvégzését is javaslom.</li>
<li>A tesztekről további infót az „Állapotfelmérések” almenüben olvashatsz.</li>
            
          </ul>

          <p className="list-main">Személyre szabott sportrehabilitáció és jógaterápia</p>
          <ul>
            <li>Ha sérülésből épülsz fel,
tartásjavításra vagy életmódváltásra van szükséged, egyénileg kidolgozott programmal segítek.</li>
          </ul>

          <p className="list-main">Egyéni jógaórák</p>
          <ul>
            <li>Ha a saját tempódban szeretnéd elsajátítani a jógát, akár kezdőként, akár
haladóként.</li>
            <li>Testgyakorlatok (Asana) – A hajlékonyság, erő és egyensúly fejlesztésére.</li>
            <li>Légzőtechnikák (Pranayama) – A belső egyensúly és energiaszint javítására.</li>
            <li>Stresszkezelés, relaxáció és meditáció – A lelki egyensúly megtalálásához.</li>
          </ul>

          <p className="list-main">Táplálkozási és életmód tanácsadás</p>
          <ul>
            <li>Segítek egy egészséges, számodra fenntartható étrend és napi rutin kialakításában.</li>
          </ul>

          <p className="list-main">Miben segíthetek még?</p>
          <ul>
            <li>Hormonális egyensúly helyreállítása</li>
            <li>Immunrendszer erősítése</li>
            <li>Idegrendszer támogatása</li>
            <li>Általános közérzet javítása</li>
            <li>Általános erőnlét, állóképesség, hajlékonyság, mobilitás, rugalmasság fejlesztése</li>
          </ul>

          <p className="list-main">
            Hiszek az egyszerű, természetes megoldásokban. A táplálkozás és a mozgás alapjaiban határozza meg az egészségünket. Az együttműködés során nemcsak a tüneteket szüntetjük meg, hanem a problémák gyökerét is feltárjuk. <br></br>Már apró, tudatos változtatásokkal is hatalmas eredményeket érhetünk el!
          </p>

          <p className="list-main">Keress bátran kortól, nemtől, előképzettségtől függetlenül.</p>
          <p className="list-main">Ár: 13.000 Ft / fő / alkalom – 1 órás</p>

        </div>

        <div className="class-description-pictures">
          <img src={Pic1} alt="Jóga kép 1" />
          <img src={Pic2} alt="Jóga kép 2" />
        </div>

      </div>
      <div className="introduction"></div>
    </div>
  </div>

  <p className="keress-batran">Keress bátran kortól, nemtől, előképzettségtől függetlenül.</p>
  <div className="random-div">
    <NavLink className="rolam-unique" to="/about">László Júlia</NavLink>
  </div>

</div>


<Footer />
</div>
  );
}

export default Humankineziologia;